/**
 * Logo MARCO — usa los PNG oficiales de /public.
 *   variant "color" → navy (fondos claros) · "white" → blanco (fondos oscuros)
 */
interface LogoProps {
  variant?: "color" | "white";
  /** alto en px (el ancho se ajusta solo) */
  height?: number;
  className?: string;
}

export function Logo({ variant = "color", height = 32, className }: LogoProps) {
  const src = variant === "white" ? "/marco-logo-white.png" : "/marco-logo.png";
  return (
    <img
      src={src}
      alt="MARCO · Soluciones integrales"
      style={{ height, width: "auto", display: "block" }}
      className={className}
    />
  );
}
